module.exports = __webpack_public_path__ + "static/img/btn-appoint1.fe3e566.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/btn-appoint1.png
// module id = s8dR
// module chunks = 7